module.exports = __webpack_public_path__ + "img/heart.af9365ac.svg";